import React from 'react'
import OffLine from '../off-line'

const OffLinePt = () => {
    return <OffLine languageCode="pt" />
}

export default OffLinePt
